import { Box, styled, TableCell } from '@mui/material';

export const Container = styled(Box)(() => ({}));

export const StyledTableCellBody = styled(TableCell)(() => ({
  color: '#475467',
  fontSize: '14px',
  fontWeight: '500',

  '& div': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },

  '& svg': {
    alignItems: 'flex-end !important',
    color: '#FFD113',
  },
}));

export const SubtitleCell = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '12px',
  fontWeight: '400',

  '& span': {
    fontSize: '12px',
    fontWeight: '400',
  },

  '& div': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },
}));

export const StyledTableCellHead = styled(TableCell)(() => ({
  backgroundColor: '#F2F4F7',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',

  '& span': {
    verticalAlign: 'bottom',
    paddingLeft: '4px',
  },
}));
